(function() {
'use strict';

const TR = angular.module('TR');
TR.directive('productExpander', function() {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            startExpanded: '=',
            watchProperty: '@',
            expandText: '@',
            collapseText: '@'
        },
        template: '<div class="product-section" ng-transclude></div>',
        transclude: true,
        controller($scope) {
            $scope.show = $scope.startExpanded || false;
        }
    };
});

TR.directive('productExpanderButton', function() {
    return {
        restrict: 'E',
        transclude: false,
        replace: true,
        scope: false,
        template: '<a href="#" ng-click="toggle()">{{buttonText}}</a>',
        link(scope) {
            scope.show = scope.$parent.show;

            const _setButtonText = function(show) {
                scope.buttonText = (show === false) ? scope.$parent.expandText : scope.$parent.collapseText;
            };

            scope.toggle = function() {
                scope.show = !scope.show;
                _setButtonText(scope.show);
            };

            _setButtonText(scope.show);

            if (scope.$parent.watchProperty) {
                const cancel = scope.$watch(scope.$parent.watchProperty, function(v) {
                    if (!v) {
                        return;
                    }
                    cancel();
                    scope.show = v;
                    _setButtonText(scope.show);
                });
            }
        }
    };
});

TR.directive('productExpanderBody', function() {
    return {
        restrict: 'E',
        transclude: true,
        replace: true,
        scope: false,
        template: '<div class="body" ng-show="show" ng-transclude></div>',
        link(scope) {
            scope.show = scope.$parent.show;
        }
    };
});
})();
